import { ThemeEvents } from '@theme/events';

document.addEventListener(ThemeEvents.FilterUpdate, () => {
  const el = document.querySelector('results-list');
  if (!el) return;
  el.setAttribute('aria-busy', 'true');

  // Clear busy on the first mutation inside results-list (the grid swap),
  // with a failsafe in case it never fires.
  const finish = () => {
    observer.disconnect();
    clearTimeout(failsafe);
    el.removeAttribute('aria-busy');
  };
  const observer = new MutationObserver(finish);
  observer.observe(el, { childList: true, subtree: true });
  const failsafe = setTimeout(finish, 3000);
});